import classNames from 'classnames';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router';
import { getMessage, getPassword } from '../api/action';
import { FixedSpace } from '../components/FixedSpace';
import { SelectionBar } from '../components/SelectionBar';
import { Space } from '../components/Space';
import * as routes from '../routing/routes';
import styles from '../assets/styles/pages/Home.module.scss';
import { Form, Formik, FormikProps } from 'formik';
import { Texts } from '../constants/Texts';
import { ErrorPopup } from '../components/ErrorPopup';
import { InputField } from '../components/InputField';
import { useCustomerContext } from '../context/Customer';
import { Sidebar } from '../components/Sidebar';
import ReactLoading from 'react-loading';
import { Button } from '../components/Button';

interface LoginFormData {
  id: string;
  companyPhoneNumber: string;
  carNumber: string;
  email: string;
  phoneNumber: string;
}

const initialValues: LoginFormData = {
  id: '',
  carNumber: '',
  email: '',
  companyPhoneNumber: '',
  phoneNumber: '',
};

export const Home = () => {
  const navigate = useNavigate();
  const [customerType, setCustomerType] = useState('private');
  const [loading, setLoading] = useState(false);
  const formicRef = useRef<FormikProps<LoginFormData>>(null);
  const isPrivateCustomer = customerType === 'private';
  const [errorText, setErrorText] = useState('');
  const customerContext = useCustomerContext();
  const onSelectCustomerType = (value: string) => {
    setCustomerType(value);
  };

  useEffect(() => {
    formicRef.current?.resetForm({
      values: {
        ...formicRef.current?.values,
        id: '',
        companyPhoneNumber: '',
      },
    });
    formicRef.current?.validateForm();
  }, [customerType]);

  const validate = useCallback(
    (values: LoginFormData) => {
      const errors: any = {};
      errors.missingRequierdFileds = !values.carNumber || !values.id || isPrivateCustomer ? !values.phoneNumber : !values.companyPhoneNumber; // || (isEmail ? !values.email : !values.phoneNumber);
      if (!validateFields(values)) errors.notValid = true;

      return errors.missingRequierdFileds || errors.notValid ? errors : null; //|| errors.email
    },
    // eslint-disable-next-line
    [isPrivateCustomer] //isEmail
  );

  const validateFields = (value: LoginFormData) => {
    if (!(Number(value.carNumber) && Number(value.id) && Number(isPrivateCustomer ? value.phoneNumber : value.companyPhoneNumber))) {
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (customerContext.currentPosition != routes.home) navigate(routes.otp);
  }, [customerContext.currentPosition]);

  const sendPassword = async (value: LoginFormData): Promise<void> => {
    setLoading(true);
    if (!validateFields(value)) setErrorText(String('invalid values'));
    const response = await getPassword(value.carNumber!, isPrivateCustomer ? '1' : '0', value.id!, value.companyPhoneNumber!, value.phoneNumber!, value.email!);
    if (response) {
      if (response.response.properties.action_value !== '0') {
        const message = await getMessage(response.response.properties.action_value);
        setErrorText(String(message));
      } else {
        const userData = {
          carNumber: value.carNumber,
          phoneNumber: value.phoneNumber,
          email: value.email,
        };
        customerContext.setUserData(userData);
        customerContext.setTimer();
        customerContext.setCurrentPosition(routes.otp);
      }
    } else {
      console.error('error', response.status, response);
    }
    setLoading(false);
  };

  return (
    <Formik innerRef={formicRef} validateOnMount={true} initialValues={initialValues} onSubmit={sendPassword} validate={validate}>
      {(formic) => (
        <Form className={styles.main}>
          <Sidebar firstHeader={Texts.WELCOME} secondHeader={Texts.PROTEXTION_CERTIFICATES} message={Texts.ENRER_DETAILS} />
          <div className={styles.container} style={{ display: 'flex', flexDirection: 'column' }}>
            <div>
              <div className={classNames(styles.message, styles.onlyMobile)}>{Texts.ENRER_DETAILS}</div>
              <div className={styles.onlyMobile}>
                <Space />
              </div>
              <div className={styles.isPrivate}>{Texts.IS_PRIVATE_VEHICLE}</div>

              <SelectionBar
                firstSelection={{
                  label: Texts.PRIVATE_CUSTOMER,
                  value: 'private',
                }}
                secondSelection={{
                  label: Texts.BUSINESS_CUSTOMER,
                  value: 'business',
                }}
                onChange={onSelectCustomerType}
                value={customerType}
              />
              <Space />
              <InputField name='id' placeHolder={isPrivateCustomer ? Texts.ENTER_ID : Texts.ENTER_COMPANY_ID} numeric />

              <Space />
              <InputField
                name={isPrivateCustomer ? 'phoneNumber' : 'companyPhoneNumber'}
                placeHolder={isPrivateCustomer ? Texts.ENTER_PHONE_NUMBER : Texts.ENTER_COMPANY_PHONE}
                numeric
              />

              <Space />
              <InputField name='carNumber' placeHolder={Texts.ENTER_CAR_NUMBER} numeric />
              <Space />
              <FixedSpace height={'1.8rem'} />
              <Button loading={loading} isValid={formic.isValid} text={Texts.GET_PASSWORD} disabledBgColor={'#8b9398'} />
            </div>
          </div>
          {errorText.length ? <ErrorPopup text={errorText} setText={setErrorText} /> : <></>}
        </Form>
      )}
    </Formik>
  );
};
